<template>
	<div class="customer-info-cls">
		<CustomerInfo :customerId="$route.params.id" sourceType="customerInfo" />
	</div>
</template>

<script>
import CustomerInfo from "@/components/CustomerInfo";
export default {
	name: "CustomerPageInfo",
	components: {
		CustomerInfo
	}
}
</script>

<style lang="scss" scoped>
.customer-info-cls {
	padding: 20px;
	box-sizing: border-box;
}
</style>